import { render } from "./ReceiverInformation_Import.vue?vue&type=template&id=0ff0f50c"
import script from "./ReceiverInformation_Import.vue?vue&type=script&lang=js"
export * from "./ReceiverInformation_Import.vue?vue&type=script&lang=js"

import "./ReceiverInformation_Import.vue?vue&type=style&index=0&id=0ff0f50c&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__